<template>
  <div class="ClassSetBox">
    <template v-if="$route.name == 'classSet'">
      <ots-main-title :mainTopBtn="mainTopBtnList" :isShowSearchIcon="false">
        <template v-slot:tabs>
          <div>
            <span class="f20 col_black">考试批次：<span>{{ planInfo.name }}</span></span>
          </div>
        </template>
      </ots-main-title>
      <ots-custom-dialog :dialog.sync="addDialog" title="自动安排" width="43%">
        <template v-slot:content>
          <h3>排序设置</h3>
          <div class="courseFlag">
            <span>报考相同科目考生安排在同一考场</span>
            <el-switch
              v-model="courseFlag"
              :active-value="1"
              :inactive-value="2"
            ></el-switch>
            <span>说明：开启后报考相同科目考生尽可能安排在同一考场</span>
          </div>
          <h3 class="classFlag">考场安排策略选择</h3>
          <el-radio-group v-model="classFlag">
            <div class="classFlagslass">
              <el-radio label="1"
                >策略1<span class="illustration">按考点容量大小依次安排（优先容量最接近考场，实现考场最大化利用）</span></el-radio
              >
            </div>
            <div class="classFlagslass1">
              <el-radio label="2"
                >策略2<span class="illustration"> 混排（各考场依次安排，尽量平均分配）</span>   </el-radio
              >
            </div>
          </el-radio-group>
        </template>
        <template v-slot:footer>
          <el-button round @click="addDialog = false">取消</el-button>
          <el-button round type="primary" @click="addSchool">确定</el-button>
        </template>
      </ots-custom-dialog>

      <ots-table-group-new
        :tableHeader="tableHeader"
        :tableData="tableData"
        :pagination="pagination"
        :batchOperBtn="batchOperBtn"
        @changeNum="changeSize"
        @changePage="changePage"
      ></ots-table-group-new>

      <!-- 批量补时 -->
      <ots-custom-dialog :dialog.sync="suppleTimeDialog" title="批量补时" width="780px" class="SuppleClass">
        <template v-slot:content>
          <div style="margin-top: -21px;">
            <h4 style="text-align: center; color: #606266;">{{ planInfo.name + '-' + SuppleInfo.name }}</h4>
          </div>
          <div class="msgBox">
            <span>考生范围</span>
            <div class="formStyle">
              <el-form ref="form" :model="SuppleForm" label-width="80px">
                <el-form-item label="考点">
                  <el-select v-model="SuppleForm.placeId" placeholder="请选择考点">
                      <el-option :label="item.name" :value="item.id" v-for="item in siteList" :key="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="教室">
                  <el-select v-model="SuppleForm.classId" placeholder="请选择教室">
                      <el-option :label="item.name" :value="item.id" v-for="item in classList" :key="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="考试课程">
                  <el-select v-model="SuppleForm.courseId" placeholder="请选择考试课程">
                    <el-option :label="item.courseName" :value="item.courseId" v-for="item in courseList" :key="item.courseId"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="关键字" v-if="false">
                  <el-input v-model="SuppleForm.searchKey" placeholder=""></el-input>
                </el-form-item>
              </el-form>
            </div>
          </div>
          <div class="msgBox" style="margin-top: 8px;">
            <span style="display: inline">补时方案 <span style="color: red;">*</span></span>
            <div class="formStyle">
              <el-form ref="form" :model="SuppleForm" label-width="80px">
                <el-form-item label="在" style="width: 100%; display: flex;">
                  <el-date-picker type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期" v-model="SuppleForm.beginExamTime" style="width: 100%;"></el-date-picker>
                  <span style="position: absolute; width: 240px;line-height: 36px; margin-left: 16px;">
                    之前开始答卷的考生&nbsp;&nbsp;
                    <el-tooltip class="item" effect="dark" content="该设置可将迟到的考生排除在不补时范围之外。" placement="top">
                      <i class="el-icon-question"></i>
                    </el-tooltip>
                  </span>
                </el-form-item>
                <el-form-item label="补时">
                  <el-input type="number" placeholder="请输入补时时间" v-model.number="SuppleForm.minutes" class="numrule" :min="1"></el-input>
                  <span style="position: absolute; width: 240px;line-height: 36px; margin-left: 16px;">分钟</span>
                </el-form-item>
              </el-form>
            </div>
          </div>
          <div class="check">
            <el-button type="primary" plain @click="inspectorNumber">核查人数范围</el-button>
          </div>
          <div class="msgBox" v-if="isInspector">
            <div class="formStyle" style="height: auto; padding-bottom: 16px;">
              <div>
                <span style="width: auto;">考生=</span>
                <el-button type="primary" plain style="padding: 4px 20px;" v-if="!SuppleForm.placeId && !SuppleForm.classId && !SuppleForm.courseId && !SuppleForm.searchKey">所有人</el-button>
                <el-button type="primary" plain style="padding: 4px 20px;" v-else>
                  {{ SuppleForm.placeId ? placeName: '全部考点' }}，
                  {{ SuppleForm.classId ? className: '全部教室' }}，
                  {{ SuppleForm.courseId ? courseName: '全部课程' }}
                  {{ SuppleForm.searchKey ? '，' + SuppleForm.searchKey + '相关' : ''}}
                </el-button>
                <span>，答卷时间早于</span>
                <el-button type="primary" plain style="padding: 4px 20px;">{{ SuppleForm.beginExamTime }}</el-button>
              </div>
              <div style="margin-top: 8px;">
                <span style="width: auto;">
                  满足该条件正在答卷的考生有
                  <span style="margin: 0 4px; color: #fe5958; width: auto; font-weight: 700;">
                  {{ studentCountNumber }}
                  </span>
                  人
                </span>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:footer>
          <el-button round @click="suppleTimeDialog = false">取消</el-button>
          <el-button round type="primary" @click="addSupple">确定</el-button>
        </template>
      </ots-custom-dialog>


      <ots-custom-dialog :dialog.sync="ImportClassDialog" title="导入考场安排结果">
        <template v-slot:content>
          <div class="exportDialog">
            <el-form ref="exportForm" :model="importForm">
              <el-form-item label="1.模板下载">
                <span
                  style="color: #006aff"
                  @click="$getStaticFile('考场安排结果导入模板.xlsx')"
                  class="cp"
                >
                  <i class="el-icon-download"></i>
                  下载考场安排结果导入模板
                </span>
              </el-form-item>
              <el-form-item v-model="importForm.Filedata">
                <ots-upload-file
                  :httpRequest="handleFormData"
                  fileType="xlsx"
                />
              </el-form-item>
            </el-form>
            <div class="impExplain">
              <span class="tipTitle"><i></i>提示：</span>
              <div>
                <div>1：模板中<span class="col_red">*</span>字段为必填项</div>
                <div>
                  2：只能上传扩展名为<span class="col_red">.xlsx</span>的文件；
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:footer>
          <el-button round @click="ImportClassDialog = false">取消</el-button>
          <el-button round type="primary" @click="rightImport">导入</el-button>
        </template>
      </ots-custom-dialog>

    </template>
    <template v-else>
      <router-view />
    </template>
  </div>
</template>
<script>
import { getCurrentPlanFn } from "@/http/modules/examSet/examBatch";
import { getPlanSite, getCourseListBySessionList, addTimeStudentCountAPI, addTimeBatchAPI } from "@/http/modules/examSet/section";
import { getClassListFn, downloadPreGeneratedAnswerPaperAPI, setStudentClassFn, publishPlanClassFn, openSignTable, exportClassRoom, getPreGeneratedAnswerPaperAPI, judgeImportArrangeClassInfoAPI, importArrangeClassInfoAPI } from "@/http/modules/examSet/planClass";

export default {
  name: "classSet",
  data() {
    return {
      addDialog: false,
      currentPlanName: "",
      needSignTable: false,
      activeName: "curentPlan",
      classForm: {
        planId: "",
        page: 1,
        size: 10,
      },
      batchOperBtn: [
        {
          title: "返回",
          click: () => {
            this.$router.go(-1);
          },
        },
      ],
      tableHeader: [
        {
          title: "考试场次",
          prop: "name",
        },
        {
          title: "考试开始时间",
          prop: "beginTime"
        },
        {
          title: "考试结束时间",
          prop: "endTime"
        },
        {
          title: "考试课程",
          prop: "courseNames",
        },
        {
          title: "考点",
          prop: "placeNames",
        },
        {
          title: "已安排",
          type: "button",
          prop: "studentCount",
          disableFn: (val) => (val.row.studentCount > 0 ? false : true),
          click: this.checkStudent,
        },
        {
          title: "操作",
          type: "buttons",
          btnList: [
            {
              title: "批量补时",
              formatter: (scope) => {
                const { beginTime, endTime } = scope.row
                let begin = Date.parse(new Date(beginTime).toString())
                let end = Date.parse(new Date(endTime).toString())
                let current = Date.now()
                if (begin < current && current < end) {
                  return false
                } else {
                  return true
                }
              },
              click: this.Click_Batch_Supple_Time,
            },
          ],
        }
      ],
      tableData: [],
      pagination: {
        total: 0,
      },
      planInfo: {},
      isUseYy: 0,
      courseFlag: 1,
      classFlag: "1",
      // 批量补时相关
      suppleTimeDialog: false,
      SuppleNumber: 0,
      SuppleInfo: {},
      SuppleForm: {
        planId: '',
        placeId: '',
        classId: '',
        courseId: '',
        searchKey: '',
        beginExamTime: '',
        sessionId: '',
        minutes : ''
      },
      siteList: [],
      classList: [],
      courseList: [],
      isInspector: false,
      studentCountNumber: 0,
      placeName: '',
      className: '',
      courseObj: '',
      isCanExportJudge: false,
      ImportClassDialog: false,
      importForm: {
        planId: "",
        file: "",
      },
    };
  },
  computed: {
    isShowFooter() {
      return this.showFooterPage.indexOf(this.$route.name) !== -1;
    },

    // 按钮控制
    mainTopBtnList() {
      let btnArr = [];
      if (this.planInfo.classPublish == 1 && this.isUseYy == 1) {
        btnArr = [
          {
            title: "下载鹰眼数据",
            fn: this.goDownSignActive,
          },
          {
            title: "下载OTS作答记录",
            fn: this.getAnswerRecord,
          }
        ];
      } else if (this.planInfo.classPublish == 0) {
        btnArr = [
          {
            title: "自动安排",
            fn: this.setClass,
            plain: true,
          },
          {
            title: "手动调整",
            fn: this.routerClass,
            plain: true,
          },
          {
            title: "一键发布",
            fn: this.publishClass,
          },
        ];
      }

      let item = {
        title: "导入考场安排结果",
        fn: this.goImportClass,
        plain: true,
      }

      if (this.isCanExportJudge) {
        btnArr.unshift(item)
      }

      return btnArr;
    },
  },
  created() {
    this.initData();
    this.getConfig();
    window.localStorage.setItem("paramslist", JSON.stringify());

    

  },
  watch: {
    "SuppleForm.placeId": function(val) {
      this.SuppleForm.classId = ""
      this.classList = [ {id: '', name: '全部'}, ...this.siteList.filter(
        (item) => item.id == val
      )[0].placeClassList ]
    },
    "SuppleForm": {
      handler(newVal) {
        this.isInspector = false
      },
      deep: true
    }
  },
  methods: {
    // 导入考场安排结果
    goImportClass() {
      this.ImportClassDialog = true;
    },

    // 执行导入考场安排结果
    rightImport() {
      this.importForm.planId = this.$route.query.id;
      if (!this.importForm.file) {
        this.$message.error("请选择文件！");
        return;
      }
      const fd = new FormData();
      for (let item in this.importForm) {
        fd.append(item, this.importForm[item]);
      }
      importArrangeClassInfoAPI(fd).then(res=>{
        if (res.code) {
          this.ImportClassDialog = false;
          const failNum = res.data.errorCount ? parseInt(res.data.errorCount): 0;
          const totalNum = parseInt(res.data.allCount);
          const successNum = totalNum - failNum;
          // let message = `导入完成，成功导入${successNum}条，失败${failNum}条`;
          let message = `导入完成，成功导入${successNum}条。`;
          let errMessage = `导入失败：存在${failNum}条不符合要求的数据，请修改后重新导入全部安排结果。`;
          
          this.$confirm(failNum > 0 ? errMessage: message, "导入结果", {
            confirmButtonText: failNum > 0 ? "查看错误记录" : "确定",
            cancelButtonText: "取消",
            type: failNum > 0 ? "warning" : "success",
          }).then(() => {
            if (failNum > 0) {
              window.location.href = res.data.address;
            }
          });
          this.getClassList();
        }
      })
    },

    handleFormData(val) {
      this.importForm.file = val.file;
    },

    /**
     * @param { 点击批量补时 }
     */
    Click_Batch_Supple_Time(row) {
      this.SuppleInfo = {...row}
      this.getSuppleTimeData(row)
      for (let key in this.SuppleForm) {
        if (key != "sessionId" && key != "planId") {
          this.SuppleForm[key] = ''
        }
      }
      this.suppleTimeDialog = true
    },

    /**
     * @param { 获取补时下拉数据 }
     */
    async getSuppleTimeData(row){
      let { planId, id } = row
      this.SuppleForm.sessionId = id
      this.SuppleForm.planId = planId
      // 考点
      const { data: siteList} = await getPlanSite({ planId, sessionId: id })
      this.siteList = [{name: '全部', id: ''}, ...siteList]
      // 课程
      const { data: courseList } = await getCourseListBySessionList({sessionId: id})
      this.courseList = [{courseName: '全部', courseId: '', placeClassList: [] }, ...courseList]
      // 教室
      this.classList = [{id: '', name: '全部'}]
    },

    /**
     * @param { 核查人数 }
     */
    async inspectorNumber(){
      let Info = JSON.parse(JSON.stringify(this.SuppleForm))
      const { beginTime, endTime } = this.SuppleInfo
      const { beginExamTime, minutes } = Info

      if (!beginExamTime && !minutes) {
        this.$message.warning("请设置补时方案！")
        return
      }

      if (!beginExamTime) {
        this.$message.warning("请选择补时开始时间！")
        return
      }

      if (!minutes) {
        this.$message.warning("请输入补时数值！")
        return
      } else if (minutes<1 || minutes%1 != 0) {
        this.$message.warning("请输入正确的补时数值！")
        return        
      }

      let begin = Date.parse(new Date(beginTime).toString())
      let end = Date.parse(new Date(endTime).toString())
      let exam = Date.parse(new Date(beginExamTime).toString())
      if (exam < begin || exam > end) {
        this.$message.warning("请选择时间在考试有效期内！")
        return
      }

      const { data, code } = await addTimeStudentCountAPI(Info)
      if (code) {
        this.isInspector = true
        this.studentCountNumber = data
      }

      const { placeId, classId, courseId } = this.SuppleForm
      let placeObj = this.siteList.find(item=>{
        return item.id === placeId
      })
      let classObj = this.classList.find(item=>{
        return item.id === classId
      })
      let courseObj = this.courseList.find(item=>{
        return item.courseId === courseId
      })
      this.placeName = placeObj.name
      this.className = classObj.name
      this.courseName = courseObj.courseName
    },

    /**
     * @param { 执行补时操作 }
     */
    addSupple() {
      if (!this.isInspector) {
        this.$message.warning("请先核查人数范围！")
        return
      }

      if (this.studentCountNumber == 0) {
        this.$message.warning('未查询到可以补时的考生，您可以重新设置补时条件！')
        return
      }

      const h = this.$createElement
      this.$confirm('', "活动补时", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        message: h('p', null, [
          h('span', null, '确定将'),
          h('span', {style: 'color: #fe5958; margin: 0 4px;'}, this.SuppleForm.beginExamTime),
          h('span', null, '之前进入考试，正在答卷的'),
          h('span', {style: 'color: #fe5958; margin: 0 4px;'}, this.studentCountNumber),
          h('span', null, '名考生批量补时'),
          h('span', {style: 'color: #fe5958; margin: 0 4px;'}, this.SuppleForm.minutes),
          h('span', null, '分钟？'),
        ])
      }).then(async () => {
        let param = {...this.SuppleForm}
        const { code } = await addTimeBatchAPI(param)
        if (code == 1) this.$message.success('批量补时成功！')
        this.suppleTimeDialog = false
      })
    },

    // 下载 OTS 作答记录
    async getAnswerRecord() {
      const {code, data} = await downloadPreGeneratedAnswerPaperAPI({planId: this.classForm.planId});
      if (code == 1) {
        window.open(data);
      }
    },

    //下载活动安排
    goDownSignActive() {
      this.$api.system.exportUserArrangement({
        planId: this.$route.query.id,
      }).then((res) => {
        if (res.data) {
          window.open(res.data);
        }
      });
    },
    // 手动安排
    ManualSet() {
      this.$router.push({ name: "ManualSet" });
    },

    async initData() {
      let { data } = await getCurrentPlanFn({
        planId: this.$route.query.id,
      });
      this.planInfo = data;
      this.classForm.planId = this.planInfo.id;
      this.getClassList();

      let result = await judgeImportArrangeClassInfoAPI({planId: this.$route.query.id})
      this.isCanExportJudge = result.data;

    },
    async getClassList() {
      const { data } = await getClassListFn(this.classForm);
      this.tableData = data.records;
      this.pagination.total = data.total;
    },
    changeSize(num) {
      this.classForm.size = num;
      this.getClassList();
    },
    changePage(p) {
      this.classForm.page = p;
      this.getClassList();
    },
    goDownSignTable() {
      this.$router.push({
        name: "signTable",
      });
    },
    async addSchool() {
      let setStudentClass = {
        planId: this.classForm.planId,
        courseFlag: this.courseFlag,
        classFlag: this.classFlag,
      }
      if (this.$route.query.planState == 4) {
        this.$confirm(
          "已做考场安排，再次安排会清除上一次安排数据，是否进行再次安排？",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        ).then(async () => {
          const { code } = await setStudentClassFn(setStudentClass);
          if (code == 1) {
            this.$message.success("安排成功");
            this.getClassList();
            this.addDialog = false;
          }
        });
      } else {
        const { code } = await setStudentClassFn(setStudentClass);
        if (code == 1) {
          this.$message.success("安排成功");
          this.getClassList();
          this.addDialog = false;
        }
      }
    },
    getConfig() {
      this.$api.system.getConfigData().then((res) => {
        let configList = res.data.configList;
        configList.forEach((item) => {
          if (item.setName == "needSignTable") {
            this.needSignTable = item.setValue == 1 ? true : false;
          }
          if (item.setName == "needMonitor") {
            this.isUseYy = item.setValue;
          }
        });
      });
    },

    /**
     * @param { 考场安排发布 }
     */
    async publishClass() {
      this.$confirm("确定要发布吗？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const { code } = await publishPlanClassFn({ planId: this.classForm.planId });
        if (code == 1) {
          this.$message.success("考场发布成功！");
          this.getClassList();
          // if (this.needSignTable) {
          //   openSignTable({ planId: this.classForm.planId });
          // }
          this.mixin_updateCurrentPlanInfo();
          // ** 考场发布接口调用成功后，调用生成桌贴接口
          // const exportClass = await exportClassRoom({planId: this.classForm.planId, typeId: 2});
          // ** 考场发布接口调用成功后，调用生成生成答卷的接口
          // const preAnswerPaper = await getPreGeneratedAnswerPaperAPI({planId: this.classForm.planId});
        }
      }).catch(() => {});
    },
    async setClass() {
      this.$confirm('自动安排会清除已安排的数据，包括手工调整的。是否要再次进行安排？',{
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async()=>{
        this.addDialog = true;
      })
    
    },
    goHistory() {
      this.$router.push({
        name: "historyClass",
      });
    },
    routerClass() {
      this.$router.push({
        name: "manualAdjustment",
        query: {
          id: this.$route.query.id,
          name: this.planInfo.name,
        },
      });
    },
    checkStudent(row) {
      window.localStorage.setItem("checkPlan", JSON.stringify(row));
      this.$router.push({
        name: "student",
        query: {
          sessionId: row.id,
          planName: this.planInfo.name,
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.mainCon {
  margin-top: 0;
  padding: 20px;
  border-radius: 8px;
  background-color: #fff;
}
.myFooter {
  width: 100%;
}
/deep/.el-switch {
  margin: 0 10px;
}
.classFlag {
  margin: 20px 0;
}
.courseFlag {
  margin: 20px 0;
}
.classFlagslass {
  margin: 20px 0;
}
.classFlagslass1 {
  margin: 30px 0 100px 0;
}
/deep/.dialog-footer {
  margin: 50px 0 !important;
}
.illustration{
  margin-left: 15px;
}

.msgBox {
  font-size: 14px;
  line-height: 2;
  color: #272e40;
  span {
    display: inline-block;
    width: 100px;
    color: #737780;
    margin-right: 10px;
  }
  .formStyle {
    width: 100%;
    height: auto;
    // background: rgba(0, 0, 0, .1);
    background: #F8F9FC;
    padding-top: 24px;
    padding-left: 16px;
    border-radius: 8px;
    .el-form {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      .el-form-item {
        width: 50%;
        height: 36px;
        display: flex;
        justify-content: left;
        margin-bottom: 16px;
        /deep/ .el-form-item__label {
          line-height: 36px;
          text-align: right;
        }
        /deep/ .el-form-item__content{
          margin: 0!important;
        }
        /deep/ .el-input .el-input__inner {
            width: 240px;
            height: 36px;
            line-height: 18px;
        }
        /deep/ .el-form-item__content {
          width: 240px;
          .el-input {
            width:240px;
          }
        }
        .el-select {
          width: 240px;
          /deep/ .el-input.el-input--suffix {
            width: 100%;
          }
          /deep/ .el-input__inner {
            width: 240px;
          }
        }

      }
    }

  }
}

.check {
  margin: 16px 0;
}
/deep/.numrule input::-webkit-outer-spin-button,
/deep/.numrule input::-webkit-inner-spin-button {
  -webkit-appearance: none!important;
}

</style>
